import React, { Component } from "react";
import { IconButton, Tooltip } from "@material-ui/core";
import {
  Edit,
  Delete,
  Check as ActiveIcon,
  Close as NotActiveIcon,
} from "@material-ui/icons";
// React Grid
import { SortingState, IntegratedSorting } from "@devexpress/dx-react-grid";
import {
  Grid,
  VirtualTable,
  TableHeaderRow,
} from "@devexpress/dx-react-grid-material-ui";
import { connect } from "react-redux";

import { API_Settings } from "apihandler/Settings";

const getRowId = (row) => row.id;

var timer = null;

class SubAccountsGrid extends Component {
  constructor(props) {
    super(props);
    this.state = {
      direction: "asc",
      recs: {
        rows: [],
        filteredRows: [],
        columns: [],
      },
    };
  }

  componentDidMount() {
    const { childRef } = this.props;
    childRef(this);
    this.loadRecords();
  }

  componentWillUnmount() {
    const { childRef } = this.props;
    childRef(undefined);
  }

  onSearch = (searchValue) => {
    const { recs } = this.state;
    const { rows, columns } = recs;
    clearTimeout(timer);
    var self = this;
    timer = setTimeout(() => {
      console.log("onSearch: ", searchValue);
      let qry = searchValue.toUpperCase();
      var list = rows.filter((row) => {
        return row.email.toUpperCase().indexOf(qry) > -1;
      });
      list = list.map((l, i) => {
        l.slno = i + 1;
        return l;
      });
      self.setState({
        recs: { rows: rows, filteredRows: list, columns: columns },
      });
    }, 500);
  };

  generateOptions = (rec) => {
    const { id, email } = rec;
    return (
      <div className="options">
        <Tooltip
          title="Edit"
          placement="bottom"
          onClick={() => this.props.togglePopupDialog(rec)}
        >
          <IconButton className="smallIcon">
            <Edit />
          </IconButton>
        </Tooltip>
        <Tooltip
          title="Delete"
          placement="bottom"
          onClick={() => this.props.onDeleteRecord(id, email)}
        >
          <IconButton className="smallIcon">
            <Delete />
          </IconButton>
        </Tooltip>
      </div>
    );
  };

  loadReloadRecords = () => {
    this.setState({
      recs: {
        loading: false,
        sorting: "asc",
        columns: [],
        rows: [],
        filteredRows: [],
      },
    });
    this.loadRecords();
  };

  loadRecords = () => {
    const { uid } = this.props.loginReducer;
    const self = this;
    const args = {
      managerId: uid,
    };
    API_Settings.getAllSubAccounts(args).then((res) => {
      console.log("getAllSubAccounts: ", res);
      if (res.Result === 200) {
        let cols = [
          { name: "slno", title: "Sl No." },
          { name: "email", title: "Email" },
          { name: "active", title: "Active" },
          { name: "vehicles", title: "Vehicles" },
          { name: "poi", title: "POI" },
          { name: "options", title: "Options" },
        ];
        let rows = [];
        res = res.Response;
        for (var i in res) {
          rows.push({
            id: res[i].id,
            slno: Number(i) + 1,
            email: res[i].email,
            active: res[i].active ? (
              <ActiveIcon style={{ fontSize: 18, color: "#008000" }} />
            ) : (
              <NotActiveIcon style={{ fontSize: 18, color: "#ff0000" }} />
            ),
            vehicles: res[i].vehicles,
            poi: res[i].poi,
            options: this.generateOptions(res[i]),
          });
        }
        self.setState({
          recs: {
            loading: false,
            sorting: "asc",
            columns: cols,
            rows: rows,
            filteredRows: [],
          },
        });
      }
    });
  };

  render() {
    const { rows, columns, filteredRows } = this.state.recs;

    const tableColumnExtensions = [
      { columnName: "slno", width: 100, align: "center" },
      { columnName: "options", width: 100, align: "center" },
      { columnName: "active", width: 100, align: "center" },
      { columnName: "poi", width: 100, align: "center" },
      { columnName: "vehicles", width: 100, align: "center" },
    ];

    let searchOn = false;
    if (document.getElementById("subAccountSearch") != null) {
      searchOn =
        document.getElementById("subAccountSearch").value.trim() === ""
          ? false
          : true;
    }

    const gridHeight = window.innerHeight / 1.5;

    return columns.length > 0 ? (
      <div id="subAccountsGrid" className="dataRGrid">
        <Grid
          rows={searchOn ? filteredRows : rows}
          columns={columns}
          getRowId={getRowId}
        >
          <SortingState
            defaultSorting={[{ columnName: "email", direction: "asc" }]}
            columnSortingEnabled={true}
            //   onSortingChange={this.changeZoneSort}
            columnExtensions={[
              { columnName: "poi", sortingEnabled: false },
              { columnName: "options", sortingEnabled: false },
            ]}
          />
          <IntegratedSorting />
          <VirtualTable
            columnExtensions={tableColumnExtensions}
            height={gridHeight}
          />
          <TableHeaderRow showSortingControls />
        </Grid>
      </div>
    ) : (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          height: gridHeight,
          alignItems: "center",
        }}
      >
        <p style={{ color: "#a1a1a1", fontSize: 14 }}>Loading...</p>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    loginReducer: state.loginReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(SubAccountsGrid);
